function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b1493c55-8c76-416c-b309-d6cfb0548992{fill:none;stroke:#f65e5c;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "abee7a24-29ac-4612-b490-53a929e41b02",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "f854b9d4-a26d-44b5-9e2c-6b1c5be6bac8",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "b1493c55-8c76-416c-b309-d6cfb0548992",
  d: "M38.4,246.1H96.8a32.52,32.52,0,0,0,32.4-32.4V103.4A32.52,32.52,0,0,0,96.8,71h-29V6H38.4A32.52,32.52,0,0,0,6,38.4V213.7A32.52,32.52,0,0,0,38.4,246.1Z"
})));

var SvgLogoIcon1 = function SvgLogoIcon1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 135.2 252.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (1).40c12dfe.svg";
export { ForwardRef as ReactComponent };